<template>
    <div class="content-wrapper-form">
        <b-form
            @submit.prevent="login"
            @keydown="form.onKeydown($event)"
            class="form-signin"
        >
            <div class="d-flex justify-content-around">
                <router-link :to="{ name: 'login' }" class="tab-dot-active">Sign In</router-link>
                <router-link :to="{ name: 'register' }" class="tab-dot">Sign Up</router-link>
            </div>
            <h2 class="mb-3 font-weight-bold text-center py-3">Get Started with <br/>Strata Connex.</h2>
            <b-alert
                v-if="resetPassword == 'successful'"
                show
                dismissible
                variant="success"
            >
                Your password has been reset successfully. Please
                Sign in.
            </b-alert>

            <div
                v-if="googleerror"
                v-text="googleerror"
                class="help-block invalid-feedback error-msg p-1 mb-1"
            ></div>

            <b-form-group>
                <b-form-input
                    type="text"
                    placeholder="Email"
                    v-model="form.email"
                    v-bind:class="{
                        'is-invalid': form.errors.has('email'),
                    }"
                ></b-form-input>
                <has-error :form="form" field="email"></has-error>
            </b-form-group>

            <b-form-group>
                <b-form-input
                    placeholder="Password"
                    type="password"
                    v-model="form.password"
                    v-bind:class="{
                        'is-invalid': form.errors.password
                    }"
                ></b-form-input>
                <has-error :form="form" field="password"></has-error>
            </b-form-group>

            <div class="d-flex justify-content-between pb-3">
                <b-form-checkbox
                    v-model="form.remember"
                    value="1"
                    unchecked-value="0"
                >Remember Me
                </b-form-checkbox>
                    <router-link :to="{ name: 'forgot-password' }">Forgot Password?</router-link>
            </div>

            <b-button
                :disabled="form.busy"
                type="submit"
                variant="primary"
                class="btn-grad mx-auto login-btn"
            >Sign In
            </b-button>
            <p class="text-center py-3">or Sign In with...</p>
            <div class="d-flex justify-content-around social-btns">
                <a :href="$root.serverBasePath +'/sociallogin/google'" class="btn btn-social" role="button"
                   aria-pressed="true">
                    Google
                </a>
                <!-- <a :href="$root.serverBasePath + '/sociallogin/linkedin'" class="btn btn-social" role="button"
                   aria-pressed="true">Linkedin
                </a>-->
            </div>
        </b-form>
    </div>
</template>

<script>
import {Form, HasError} from "vform";
import GoogleLogin from "vue-google-login";

Vue.component(HasError.name, HasError);

export default {
    components: {
        GoogleLogin,
        // RegisterText,
    },
    props: {
        resetPassword: {type: String, required: false}
    },
    //  props: ,
    data() {
        return {
            subPage: 'login',
            loginText: 'text',
            params: {
                client_id:
                    "241606855058-96bb8snkq7b4qsj5n02f2b3ukr7jmvbd.apps.googleusercontent.com"
            },
            renderParams: {
                width: 250,
                height: 50,
                longtitle: true
            },
            form: new Form({
                email: "",
                password: "",
                device_name: "web",
                remember: 0
            }),
            googleerror: ""
        };
    },
    mounted() {
        // this.$parent.whoami();
        this.$emit('whoami')
    },
    methods: {
        onSuccess(googleUser) {
            axios
                .post("api/socialLogin", {
                    type: "google",
                    token: googleUser.tc.access_token
                })
                .then(response => {
                    if (response.data.vuex_data != null) {
                        this.$store.commit(
                            "setUserLoggedIn",
                            response.data.vuex_data
                        );
                        window.axios.defaults.headers.common["Authorization"] =
                            "Bearer " + response.data.token;
                        if (response.data.vuex_data.role == "manager") {
                            this.$router.push({
                                name: "register-manager",
                                params: {step: 2}
                            });
                        } else if (
                            response.data.vuex_data.role == "contractor"
                        ) {
                            this.$router.push({
                                name: "register-contractor",
                                params: {step: 2}
                            });
                        }
                    } else {
                        this.googleerror = response.data.error;
                    }
                });
        },
        linkedIn() {
            axios
                .post(
                    "api/socialLogin",
                    {
                        type: "linked_in"
                    },
                    {
                        headers: {"Access-Control-Allow-Origin": "*"}
                    }
                )
                .then(response => {

                });
            // This only gets the user information: id, name, imageUrl and email
        },
        login() {
                this.$root.$data.bsLoader = true;
                this.form.post("login").then(() => {
                // window.location.reload();
                this.$emit('whoami');
                //  this.$root.$data.bsLoader = false;
                // this.$parent.whoami();

            }).catch((err) => {
                 this.$root.$data.bsLoader = false;
            });
        },

        changeSubpageTo(page) {
            this.subPage = page;
        },
        changeLogintextTo(text) {
            this.loginText = text;
        }
    }
};
</script>

<style scoped>
@media screen and (max-width: 400px) {
    .form-signin br {
        display: none;
    }

    .form-signin h2 {
        font-size: 1.5rem;
    }
}
</style>
